export const CLEAR_STATE = 'CLEAR_STATE';

export const clearState = () => ({
    type: CLEAR_STATE,
});
